import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  UpdateOwnFinancialLimitEntity,
  UpdateUserFinancialLimitDto,
  UserWalletManageService,
} from 'services/openapi';

import { UserServiceQueryKeys } from '../constants';

type UpdateUserFinancialLimitsMutationVariables = {
  userId: string;
  requestBody: UpdateUserFinancialLimitDto;
};

export const useUpdateUserFinancialLimitsMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      UpdateOwnFinancialLimitEntity,
      Error,
      UpdateUserFinancialLimitsMutationVariables
    >({
      mutationFn: (variables: UpdateUserFinancialLimitsMutationVariables) => {
        return UserWalletManageService.userManageControllerUpdateUserFinancialLimits(
          variables.userId,
          variables.requestBody,
        );
      },
      onSuccess: (_data, variables) =>
        Promise.all([
          queryClient.invalidateQueries([
            UserServiceQueryKeys.GET_USER_INFO,
            { userId: variables.userId },
          ]),
          queryClient.invalidateQueries([UserServiceQueryKeys.GET_USERS_LIST]),
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
